import { service } from '.';

export default {
  getAll: (data) => service.post('/connectings/paginet', data),
  update: (id, data) => service.put(`/connectings/${id}`, data),
};
